import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { buildQuery } from "../../additional/functions";
import { BaseQueryErrorHandler } from "./@utils/BaseQueryErrorHandler";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: "/api/v2/ai-host/keyword",
  prepareHeaders: (headers) => {
    headers.set("Content-Type", "application/json");

    return headers;
  },
});

const baseQuery = BaseQueryErrorHandler(rawBaseQuery);

const transformKeywordsResponse = (response) => {
  const rules = [];

  response?.keyword_rules?.forEach((item) => {
    const titleRule = item.rules.find((r) => r.field === "title");
    const jobLevelRule = item.rules.find((r) => r.field === "job_level");
    const jobAreaRule = item.rules.find((r) => r.field === "job_area");
    const customLevelRule = item.rules.find((r) => r.field === "custom_level");

    rules.push({
      mapping: item?.mapping,
      logic_operand: item?.operator_between_rules,
      title_operand: titleRule?.operator,
      title_values: titleRule?.values || [],
      job_level_values: jobLevelRule?.values || [],
      job_area_values: jobAreaRule?.values || [],
      custom_level_values: customLevelRule?.values || [],
    });
  });

  return { rules, id: response.id };
};

export const aliasesConstructorApi = createApi({
  reducerPath: "aliasesConstructorApi",
  baseQuery,
  endpoints: (builder) => ({
    getKeywordList: builder.query({
      query: ({ block, client, cid }) =>
        `/list${buildQuery({ block, client, cid })}`,
    }),
    getKeywordLatestVersion: builder.query({
      query: ({ block, client, cid }) =>
        `/latest_version${buildQuery({ block, client, cid })}`,
      transformResponse: (response) => transformKeywordsResponse(response),
    }),
    getKeyword: builder.query({
      query: ({ id }) => `/?id=${id}`,
    }),
    putKeyword: builder.mutation({
      query: ({ id, keywordsArray }) => ({
        url: `/?id=${id}`,
        method: "PUT",
        body: { keyword_rules: keywordsArray },
      }),
    }),
    postKeyword: builder.mutation({
      query: ({ block, cid, client, keywordsArray }) => ({
        url: `/`,
        method: "POST",
        body: { block, cid, client, keyword_rules: keywordsArray },
      }),
    }),
    deleteKeyword: builder.mutation({
      query: ({ id }) => ({
        url: `/?id=${id}`,
        method: "DELETE",
      }),
    }),
    postAssistantRequest: builder.mutation({
      query: ({ documentParams, requirements }) => ({
        url: `/assistant?${documentParams.toString()}`,
        method: "POST",
        body: { requirements },
      }),
      transformResponse: (response) => transformKeywordsResponse(response),
    }),
  }),
});

export const {
  useGetKeywordListQuery,
  useGetKeywordLatestVersionQuery,
  useGetKeywordQuery,
  usePutKeywordMutation,
  usePostKeywordMutation,
  useDeleteKeywordMutation,
  usePostAssistantRequestMutation,
} = aliasesConstructorApi;
